import { AlertTriangle, Info } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/**
 * Shared banner shown at the top of every MIFT decision-support tool.
 * `showHague` renders the additional urgent-abduction/wrongful-retention notice.
 */
export default function PreToolDisclaimer({ showHague = false }) {
  const { t } = useLang();
  return (
    <div className="mt-6 grid gap-3" data-testid="pre-tool-disclaimer">
      <div className="rounded-xl border border-blue-500/30 bg-blue-500/5 p-4 flex items-start gap-3">
        <Info className="w-4 h-4 mt-0.5 text-blue-300 flex-shrink-0" />
        <p className="text-sm text-slate-300 leading-relaxed">{t.disclaimer.pre_tool}</p>
      </div>
      {showHague && (
        <div
          className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-4 flex items-start gap-3"
          data-testid="hague-urgency-notice"
        >
          <AlertTriangle className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" />
          <p className="text-sm text-amber-100 leading-relaxed">{t.disclaimer.hague_urgency}</p>
        </div>
      )}
    </div>
  );
}
